/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  PostV2AuthLoginQuery,
  GetOauth2AuthorizationGoogleQuery,
  GetOauth2AuthorizationFigmaQuery,
  PostV2AuthTokenRefreshBody,
  PostV2AuthSignupBody,
  PostV2AuthLoginBody,
  PostV2AuthTokenRefreshResponse,
  PostV2AuthSignupResponse,
  PostV2AuthLoginResponse,
} from '../types';

export class Auth extends Controller {
  async postV2AuthTokenRefresh<
    T extends PostV2AuthTokenRefreshResponse,
    D,
    C extends PostV2AuthTokenRefreshBody
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/v2/auth/token/refresh',
      body,
      axiosConfig
    );
  }

  async postV2AuthSignup<
    T extends PostV2AuthSignupResponse,
    D,
    C extends PostV2AuthSignupBody
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/v2/auth/signup',
      body,
      axiosConfig
    );
  }

  async postV2AuthLogin<
    T extends PostV2AuthLoginResponse,
    D,
    C extends PostV2AuthLoginBody
  >(
    body: C,
    query: PostV2AuthLoginQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      this.composeUrl('/v2/auth/login', query),
      body,
      axiosConfig
    );
  }

  async getOauth2AuthorizationGoogle<T, D, C>(
    query: GetOauth2AuthorizationGoogleQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl('/oauth2/authorization/google', query),
      axiosConfig
    );
  }

  async getOauth2AuthorizationFigma<T, D, C>(
    query: GetOauth2AuthorizationFigmaQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl('/oauth2/authorization/figma', query),
      axiosConfig
    );
  }
}
